"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var FormControl_1 = __importDefault(require("@mui/material/FormControl"));
var Switch_1 = __importDefault(require("@mui/material/Switch"));
var formik_1 = require("formik");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
function SwitchButton(_a) {
    var label = _a.label, name = _a.name, readOnly = _a.readOnly, onChange = _a.onChange, value = _a.value;
    var _b = __read((0, formik_1.useField)(name), 1), field = _b[0];
    var setFieldValue = (0, formik_1.useFormikContext)().setFieldValue;
    var handleChange = function (event) {
        setFieldValue(name, event.target.checked);
    };
    return ((0, jsx_runtime_1.jsx)(FormControl_1.default, __assign({ variant: "standard", fullWidth: true }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", spacing: 2, alignItems: "center", ml: 0.5 }, { children: [label !== '' && ((0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: "h3", color: "black", sx: { textTransform: 'none' } }, { children: label }))), (0, jsx_runtime_1.jsx)(Switch_1.default, { inputProps: { 'aria-label': label }, name: name, checked: value !== undefined ? value : field.value, onChange: onChange || handleChange, disabled: readOnly })] })) })));
}
exports.default = SwitchButton;
SwitchButton.defaultProps = {
    label: '',
    readOnly: false,
    onChange: undefined,
    value: undefined,
};
//# sourceMappingURL=SwitchButton.js.map